// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2ZRII","hus":"FVlHb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Hus/Hus.scss
 ** module id = 449
 ** module chunks = 0
 **/